import { createAsyncThunk } from "@reduxjs/toolkit";

import { ErrorWithCode } from "Api/types/ErrorWithCode";
import logger from "Libs/logger";
import client from "Libs/platform";
import { isJson } from "Libs/utils";
import { AsyncThunkOptionType } from "Reducers/types";

import type { GetOrganizationOrderPropType } from "../types";
import type { OrganizationOrder } from "@packages/client";

export const getOrganizationOrderThunk = createAsyncThunk<
  OrganizationOrder | undefined,
  GetOrganizationOrderPropType,
  AsyncThunkOptionType<{ error: ErrorWithCode }>
>(
  "organization/order",
  async ({ organizationId, orderId, includeDetails }, { rejectWithValue }) => {
    try {
      const order = await client.getOrganizationOrder(
        organizationId,
        orderId,
        includeDetails
      );

      return order;
    } catch (_error: unknown) {
      // The orders API answers with application/problem+json, which the
      // client does not recognize as JSON, so it rejects with the raw body.
      const error = (
        isJson(_error) ? JSON.parse(_error) : _error
      ) as ErrorWithCode;
      if (![404, 403].includes(error.code ?? error.status ?? 0)) {
        logger(error, {
          action: "organization_load_orders",
          orderId
        });
      }

      return rejectWithValue({ error });
    }
  }
);
